import React, { Component } from 'react';
const iconArrow = require('../../../../public/img/tampa/ui/icon-arrow-forward.png');

class BackButtonTampa extends Component {
  renderBackButton = () => {
    return (
      <div>
        <div style={{ position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" }}>
          <span style={{ position: "absolute", top: "0.208333333vh", fontSize: '.96vh', color: '#143e77', right: "0.91145833333333333333vh" }}>BACK</span>
        </div>
        <div style={{ position: "absolute", marginLeft: '.3vh', marginTop: "0.5vh", left: ".231481481481481481vh", width:"100%", top: "1.5vh" }}>
          <img className="fliph" alt="back" style={{ position: "absolute", width: '1.5vh', height: '1.5vh', right: "1.5625vh" }} src={iconArrow} />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.mode === "video" ?
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left }}>
            {this.renderBackButton()}
          </div>
          :
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border }}>
            <div>
              {this.renderBackButton()}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default BackButtonTampa


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/BackButtonTampa.jsx